
 
    let sideMenu = document.querySelector('.header__hamburger');
    let hamburgerMenu = document.querySelector('.header__navigation__hamburger--icon');
    let innerHamburgerMenu = document.querySelector('.hamburgermenu__icon');
    let closeMenu = document.querySelector('.hamburgermenu__close');
    let childLink = document.getElementsByClassName('hamburgermenu__link-and-icon');
    let megaMenuSideLinkTitle = document.getElementsByClassName('megamenu__sidebar__anchor ');
    let childrenWrapper = document.getElementsByClassName('megamenu__links__wrapper')
    let title;
    let menuChildren;
    let header = document.querySelector('.header');
    let sticky = document.querySelector('#shopify-section-header');


    let mainNavLi = document.querySelectorAll('.navigation__li')
      let firstAnchor = document.querySelectorAll(".megamenu__sidebar > .megamenu__sidebar__anchor:first-child")
      let firstWrapper = document.querySelectorAll('.megamenu__navigation > .megamenu__links__wrapper:first-child')

    hamburgerMenu.addEventListener('click',function(e){          
        sideMenu.classList.toggle('header__hamburger--active') 
        if(header.parentNode.tagName.toLowerCase() == 'sticky-header' && sideMenu.classList.contains('header__hamburger--active')){
          document.body.classList.add("menu-open")
        }             
       }
    );

    innerHamburgerMenu.addEventListener('click',function(e){          
        sideMenu.classList.toggle('header__hamburger--active')
        document.body.classList.toggle("menu-open")              
       }
    );

    closeMenu.addEventListener('click', function(){
        sideMenu.classList.remove('header__hamburger--active')
        document.body.classList.remove("menu-open")
    })


// Mega Menu

    for (let title of firstAnchor) {
        title.classList.add('megamenu__sidebar__anchor--active')
      }
  
      for (let menuWrap of firstWrapper) {
        menuWrap.classList.add('megamenu__links__wrapper_open')
      }
  
    Array.from(childLink).forEach((link)=>{
        link.addEventListener('click', function(e){
            e.currentTarget.nextElementSibling.classList.toggle('hamburgermenu__dropdown_show');
             e.currentTarget.querySelector('.hamburgermenu__a__icon').classList.toggle('hamburgermenu__a__icon_up');
        })
    })

    for (let navLi of mainNavLi) {
        navLi.addEventListener('mouseenter', function () {
          for (let link of navLi.querySelectorAll('.megamenu__sidebar__anchor')) {
            link.addEventListener("mouseenter", function (e) {
              title = e.currentTarget.dataset.title
              Array.from(navLi.querySelectorAll('.megamenu__sidebar__anchor')).forEach((l) => l.classList.remove('megamenu__sidebar__anchor--active'))
              link.classList.add('megamenu__sidebar__anchor--active')
              Array.from(navLi.querySelectorAll('.megamenu__links__wrapper')).forEach(
                section => {
                  section.classList.toggle('megamenu__links__wrapper_open', section.dataset.children === title)
                }
              );
  
            })
          }
        })
      }
    

   